import { inject, Pipe, PipeTransform } from '@angular/core';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { StoryblokLink } from '../storyblok-types';
@Pipe({
  name: 'storyblokLink',
  standalone: true,
  pure: false,
})
export class storyblokLinkPipe implements PipeTransform {
  private storyblokService = inject(PICFLOW_STORYBLOK);
  transform(value: StoryblokLink): string {
    return this.storyblokService.getUrlLink(value);
  }
}
